
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ocean-ev-charger",
      function () {
        return require("private-next-pages/ocean-ev-charger/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ocean-ev-charger"])
      });
    }
  